<template>
    <b-modal id="updatemodal" ref="updatemodal" centered title="Are you sure?" :lazy="true" @show="getSelectedSites" class="updatepopup" :hide-header-close="true">
        <div class="prompt-text">
            Updating...
        </div>
        <b-row class="update-count-container">
            <b-col v-for="(updates,key) in updateArray" :key="key">
                <div class="update-count">
                    {{updates.length}}
                </div>
                <div class="update-type">
                    <i class="img-icon " v-bind:class="key"></i>
                    {{key}}
                </div>
            </b-col>
        </b-row>
        <b-row class="sitelist-container">
            <div class="card">
                <div class="card-header">
                    This action will affect in selected websites:
                </div>
                <div class="card-body">
                    <div class="site-name" v-for="site in sites" :key="site.siteID">
                        <img class="favicon-img" :src="appInfo.APP_URL_V2+site.favicon" /> {{site.siteName}}
                    </div>
                </div>
            </div>
        </b-row>
        <div slot="modal-footer" class="w-100">
            <div class="text-right">
                <b-btn class="" variant="flat" @click="close">
                    No! Don't
                </b-btn>
                <b-btn variant="primary" @click="updateAll">
                    Yes! Go Ahead
                </b-btn>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
  name: 'updatemodal',
  props: ['updates'],
  data() {
    return {
      updateArray: {},
      sites: [],
      serverURL: window.serverURL
    };
  },
  computed: {
    appInfo() {
      return this.$store.getters.getAppInfo;
    }
  },
  methods: {
    getSelectedSites() {
      this.updateArray = _.groupBy(this.updates, 'type');
      this.sites = _.uniqBy(this.updates, 'siteID');
    },
    close() {
      this.$refs.updatemodal.hide();
    },
    updateAll() {
      this.$emit('yes', { value: this.updates });
    }
  }
};
</script>

<style scoped>
.update-count-container {
  padding: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/UpdateModal.vue